import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
  ArrowRightOutlined,
  CheckCircleFilled,
  ClockCircleOutlined,
  CloseOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  GlobalOutlined,
  MailOutlined,
  MenuOutlined,
  PhoneOutlined,
  SafetyCertificateOutlined,
  TeamOutlined,
  ToolOutlined
} from '@ant-design/icons';
import './App.css';

import logo from './assets/current/slide-01-01.jpg';
import qrCode from './assets/current/slide-01-02.png';
import bsciLogo from './assets/current/slide-01-03.png';
import smetaLogo from './assets/current/slide-01-04.png';
import showroom from './assets/current/slide-03-02.png';
import sampleProduct from './assets/current/slide-03-03.jpg';
import factory from './assets/current/slide-03-04.png';
import turnoverChart from './assets/current/slide-04-01.png';
import marketChart from './assets/current/slide-04-02.png';
import brandBoard from './assets/current/slide-05-01.png';
import productBoard from './assets/current/slide-07-01.png';
import knitStack from './assets/current/slide-07-02.jpg';
import yarn from './assets/current/slide-07-03.png';
import machineApex from './assets/current/slide-08-01.png';
import machineWholeGarment from './assets/current/slide-08-02.png';
import machineSsr from './assets/current/slide-08-03.jpg';
import machineIntarsia from './assets/current/slide-08-04.png';
import machineSvr from './assets/current/slide-08-05.png';
import machineCixing from './assets/current/slide-08-06.png';
import machineLine from './assets/current/slide-08-07.png';
import embroidery from './assets/current/slide-09-01.png';
import yarnStorage from './assets/current/slide-10-01.png';
import yarnWinding from './assets/current/slide-10-02.png';
import knittingOperator from './assets/current/slide-10-03.png';
import knittingFloor from './assets/current/slide-10-04.png';
import programming from './assets/current/slide-10-05.png';
import colorChecking from './assets/current/slide-10-07.png';
import linkingFloor from './assets/current/slide-11-01.png';
import handLinking from './assets/current/slide-11-03.png';
import finishingFloor from './assets/current/slide-11-04.png';
import washing from './assets/current/slide-11-05.png';
import ironing from './assets/current/slide-11-06.png';
import drying from './assets/current/slide-11-07.png';
import factoryLayout from './assets/current/slide-12-01.png';
import qcPart from './assets/current/slide-13-01.png';
import qcNeedle from './assets/current/slide-13-02.png';
import qcLight from './assets/current/slide-13-03.jpg';
import qcColor from './assets/current/slide-13-04.jpg';
import qcInspection from './assets/current/slide-13-05.jpg';
import qcNeedles from './assets/current/slide-13-06.jpg';
import qcHumidity from './assets/current/slide-13-07.jpg';
import mapImage from './assets/current/slide-16-03.png';

const navItems = [
  ['about', 'About'],
  ['market', 'Market'],
  ['products', 'Products'],
  ['facilities', 'Facilities'],
  ['production', 'Production'],
  ['factory-layout', 'Factory plan'],
  ['quality', 'Quality'],
  ['milestones', 'Milestones'],
  ['contact', 'Contact']
];

const markets = [
  {
    region: 'Japan',
    trading: 'MNIF, Moririn, MKJ, Shigematsu, Lookmode',
    distributors: 'United Arrows, Baycrews, Kosugi, GIM, Fujistar, Aoyama, Taras, Sojitz, Yamato, Worldtex',
    brands: 'United Arrows, Beauty & Youth, Green Label, BC Stock, 417 by Edifice, Golden Bear, Adabat, Dresserior, Takeo Kikuchi, Sea Green, Technica'
  },
  {
    region: 'Korea',
    trading: 'KC',
    distributors: 'Seokyung, Dooriplus, Chen',
    brands: 'Musinsa, Louis Castel, Hazzys, JDX, PXG'
  },
  {
    region: 'USA',
    trading: 'Invest Wisdom',
    distributors: 'Johnnie-O, State & Liberty, Onward Reserve',
    brands: 'Johnnie-O, State & Liberty, Onward Reserve'
  },
  {
    region: 'United Kingdom',
    trading: 'Rextrek',
    distributors: 'Holderness & Bourne, Collars & Co.',
    brands: 'Holderness & Bourne, Collars & Co.'
  },
  {
    region: 'Italy',
    trading: 'Zerbi Roberto',
    distributors: 'Zerbi Roberto',
    brands: 'Martina Ferry, Valentino Rama and more'
  },
  {
    region: 'Vietnam',
    trading: 'Hoang Duong, Elise, IVY Moda, Prominent, Savani, Routine, South Asia (VN)',
    distributors: 'Canifa, Elise, IVY Moda, Owen, Du Tai, South Asia (VN)',
    brands: 'Canifa, Elise, IVY Moda, Metagent, Owen, Savani, Routine, Old Navy, Loft, Banana Republic, Brooks Brothers, Amazon and more'
  }
];

const brandLogoGroups = [
  {
    region: 'Japan',
    code: 'JP',
    note: 'Core market',
    className: 'is-wide',
    logos: [
      { label: 'United Arrows', crop: [34, 38, 174, 78] },
      { label: 'Beauty & Youth', crop: [207, 25, 170, 92] },
      { label: 'Green Label Relaxing', crop: [389, 35, 176, 86] },
      { label: '417 by Edifice', crop: [604, 31, 120, 82] },
      { label: 'Dresserior', crop: [33, 157, 212, 62] },
      { label: 'Adabat', crop: [253, 153, 150, 68] },
      { label: 'Takeo Kikuchi', crop: [440, 143, 156, 84] },
      { label: 'Golden Bear', crop: [523, 242, 216, 87] }
    ]
  },
  {
    region: 'Korea',
    code: 'KR',
    note: 'Growth market',
    logos: [
      { label: 'Musinsa', crop: [34, 421, 220, 72] },
      { label: 'Louis Castel', crop: [278, 400, 204, 98] },
      { label: 'JDX', crop: [550, 368, 181, 66] },
      { label: 'Linking Golf', crop: [546, 433, 184, 70] }
    ]
  },
  {
    region: 'USA',
    code: 'US',
    note: 'North America',
    logos: [
      { label: 'Johnnie-O', crop: [33, 517, 121, 42] },
      { label: 'Onward Reserve', crop: [176, 518, 236, 76] },
      { label: 'State & Liberty', crop: [176, 594, 227, 78] }
    ]
  },
  {
    region: 'United Kingdom',
    code: 'UK',
    note: 'European market',
    logos: [
      { label: 'Holderness & Bourne', crop: [410, 515, 330, 75] },
      { label: 'Collars & Co.', crop: [434, 598, 282, 73] }
    ]
  },
  {
    region: 'Italy',
    code: 'IT',
    note: 'European market',
    logos: [
      { label: 'Martina Ferry', text: true },
      { label: 'Valentino Rama', text: true }
    ]
  },
  {
    region: 'Vietnam',
    code: 'VN',
    note: 'Domestic market',
    className: 'is-full',
    logos: [
      { label: 'Elise', crop: [34, 708, 196, 73] },
      { label: 'Routine', crop: [233, 704, 223, 86] },
      { label: 'Savani', crop: [451, 699, 160, 110] },
      { label: 'Canifa', crop: [613, 701, 124, 112] },
      { label: 'IVY moda', crop: [34, 801, 188, 78] },
      { label: 'Owen', crop: [242, 818, 246, 65] }
    ]
  }
];

const knittingMachines = [
  ['SHIMA SEIKI', 'SSR112-SV / Wide Gauge', '3.5G, 5G, 7G', '9 sets'],
  ['SHIMA SEIKI', 'SSR112-SV / Wide Gauge', '12G, 14G', '41 sets'],
  ['SHIMA SEIKI', 'N.SVR122 / Single Gauge', '16G', '8 sets'],
  ['SHIMA SEIKI', 'N.SIR123SP / Single Gauge — Intarsia, In-lay, I-plating', '16G', '2 sets'],
  ['SHIMA SEIKI', 'M153XS-15L / WholeGarment', '12G, 14G', '4 sets'],
  ['SHIMA SEIKI', 'N.SVR183-21G / WholeGarment', '12G, 14G', '2 sets'],
  ['CI-XING', 'GE3-52C / Triple-system computerized flat knitting machine', '14G', '30 sets']
];

const linkingMachines = [
  ['20G', '17'], ['18G', '46'], ['16G', '80'], ['14G', '10'], ['12G', '14'],
  ['10G', '6'], ['8G', '20'], ['6G', '8'], ['5G', '5']
];

const otherMachines = [
  ['Sewing', 'China / Jack A5WS', 'Machine', '12'],
  ['Over sewing', 'Japan / JUKI', 'Machine', '2'],
  ['Button attachment', 'Japan / JUKI', 'Machine', '1'],
  ['Button-hole machine', 'Japan / JUKI', 'Machine', '1'],
  ['Button wrapping machine', 'China / Local', 'Machine', '1'],
  ['Luis stitch machine', 'Japan / YAMATO', 'Machine', '2'],
  ['3-needle over sewing', 'China / JACK', 'Machine', '2'],
  ['Steam iron tables', 'Vietnam', 'Set', '20'],
  ['Washing / squeezing', 'China / XISHENG', 'Set', '3'],
  ['Drying', 'China / XISHENG', 'Set', '5'],
  ['Yarn winding', 'China', 'Headers', '24'],
  ['Soft-water treatment system', 'Vietnam', 'Set', '2'],
  ['Boiler', 'China', 'Set', '7'],
  ['Needle detector machine', 'Japan / HASHIMA', 'Machine', '1'],
  ['Hand needle detector', 'Japan / HASHIMA', 'Set', '1'],
  ['Color checking box', 'China / TILO', 'Set', '1'],
  ['Needle-bed auto washing system', 'China / Local', 'Set', '1'],
  ['Embroidery machine', 'China / SBL', '4-head machine', '1']
];

const productionGallery = [
  [yarnStorage, 'Yarn storage'], [yarnWinding, 'Yarn winding'], [knittingOperator, 'Knitting preparation'],
  [knittingFloor, 'Knitting'], [programming, 'Programming'], [colorChecking, 'Color checking'],
  [linkingFloor, 'Linking'], [handLinking, 'Hand linking'], [finishingFloor, 'Finishing'],
  [washing, 'Washing'], [ironing, 'Ironing'], [drying, 'Drying']
];

const qualityGallery = [
  [qcPart, 'Part checking'], [qcNeedle, 'Needle detection'], [qcLight, 'Light checking'],
  [qcColor, 'Part & color checking'], [qcInspection, '3rd-party inspection room'],
  [qcNeedles, 'Dangerous-object control'], [qcHumidity, 'Humidity checking']
];

const milestones = [
  ['2016', 'Company established on Feb 26. Knitting machines installed in October.'],
  ['2017', 'First shipment to the Japanese market — Moririn.'],
  ['2019', 'Started business with MNIF and other Japanese customers and brands; expanded knitting capacity.'],
  ['2024', 'Installed WholeGarment, I-plating and In-lay knitting technology, including new 16G machines.'],
  ['2025', 'Moved to a new workshop, expanded capacity, achieved BSCI & SMETA, and developed markets in the USA, EU and Australia.']
];

const reveal = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0, transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1] } }
};

function Reveal({ children, className = '' }) {
  return (
    <motion.div className={className} variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: '-80px' }}>
      {children}
    </motion.div>
  );
}

function SectionHeading({ eyebrow, title, copy }) {
  return (
    <div className="section-heading">
      <span className="eyebrow">{eyebrow}</span>
      <h2>{title}</h2>
      {copy && <p>{copy}</p>}
    </div>
  );
}

function BrandLogo({ item }) {
  if (item.text) {
    return (
      <div className="brand-logo brand-logo-text" title={item.label}>
        <span>{item.label.charAt(0)}</span>
        <strong>{item.label}</strong>
      </div>
    );
  }

  const [x, y, width, height] = item.crop;
  const cropStyle = {
    width: `min(100%, ${Math.round((68 * width) / height)}px)`,
    aspectRatio: `${width} / ${height}`
  };
  const imageStyle = {
    width: `${(792 / width) * 100}%`,
    left: `${(-x / width) * 100}%`,
    top: `${(-y / height) * 100}%`
  };

  return (
    <div className="brand-logo" title={item.label} aria-label={item.label}>
      <div className="logo-crop" style={cropStyle}>
        <img src={brandBoard} alt="" aria-hidden="true" style={imageStyle} />
      </div>
    </div>
  );
}

function MarketLogoCard({ group }) {
  const market = markets.find((item) => item.region === group.region);

  return (
    <article className={`market-logo-card ${group.className || ''}`}>
      <div className="market-logo-card-heading">
        <div className="market-identity">
          <span className="market-code">{group.code}</span>
          <div><small>{group.note}</small><h3>{group.region}</h3></div>
        </div>
        <span className="market-brand-count">{group.logos.length} brands</span>
      </div>
      <div className="market-logo-grid">
        {group.logos.map((item) => <BrandLogo key={item.label} item={item} />)}
      </div>
      {/* <p className="market-trading"><span>Trading partners</span>{market.trading}</p> */}
    </article>
  );
}

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="site-shell">
      <header className="site-header">
        <a className="brand" href="#top" onClick={closeMenu} aria-label="Topmode home">
          <img src={logo} alt="Topmode Textile logo" />
          <span><strong>TOPMODE</strong><small>TEXTILE CO., LTD.</small></span>
        </a>
        <button className="menu-button" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle navigation" aria-expanded={menuOpen}>
          {menuOpen ? <CloseOutlined /> : <MenuOutlined />}
        </button>
        <nav className={menuOpen ? 'main-nav is-open' : 'main-nav'} aria-label="Primary navigation">
          {navItems.map(([id, label]) => <a key={id} href={`#${id}`} onClick={closeMenu}>{label}</a>)}
        </nav>
      </header>

      <main>
        <section id="top" className="hero">
          <div className="hero-orb hero-orb-one" />
          <div className="hero-orb hero-orb-two" />
          <div className="hero-content">
            <motion.div className="hero-copy" initial={{ opacity: 0, x: -34 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }}>
              <span className="hero-kicker">Company Profile · Updated 01 July 2026</span>
              <h1>Advanced knitwear.<br /><em>Reliable delivery.</em></h1>
              <p>TOPMODE is a Vietnam-based flat-bed knitwear manufacturer combining modern knitting technology, one-million-piece annual capacity and rigorous process control.</p>
              <div className="hero-actions">
                <a className="button button-primary" href="#about">Discover Topmode <ArrowRightOutlined /></a>
                <a className="button button-secondary" href="#contact">Contact our team</a>
              </div>
              <div className="hero-certifications" aria-label="Certifications">
                <div className="certification-card"><span>Social compliance</span><img src={bsciLogo} alt="BSCI certification" /></div>
                <div className="certification-card"><span>Ethical trade audit</span><img src={smetaLogo} alt="SMETA certification" /></div>
              </div>
            </motion.div>
            <motion.div className="hero-visual" initial={{ opacity: 0, scale: 0.94 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.9, delay: 0.1 }}>
              <img className="hero-factory" src={factory} alt="Topmode factory" />
              <div className="hero-badge"><span>Since</span><strong>2016</strong></div>
              <div className="hero-capacity"><strong>1,000,000</strong><span>pieces / year</span></div>
            </motion.div>
          </div>
          <div className="stat-strip">
            <div><strong>300</strong><span>employees</span></div>
            <div><strong>3,000 m²</strong><span>factory floor</span></div>
            <div><strong>96</strong><span>knitting machines</span></div>
            <div><strong>206</strong><span>linking machines</span></div>
          </div>
        </section>

        <section id="about" className="section section-light">
          <div className="container">
            <Reveal><SectionHeading eyebrow="About the company" title="Built for precision, scale and long-term partnerships" copy="Established on February 26, 2016, TOPMODE produces flat-bed knitwear for international and domestic customers from Hanoi, Vietnam." /></Reveal>
            <div className="about-grid">
              <Reveal className="about-story">
                <div className="metric-grid">
                  <div><span>Establishment</span><strong>26.02.2016</strong></div>
                  <div><span>Employees</span><strong>300 people</strong></div>
                  <div><span>Productivity</span><strong>1M pcs/year</strong></div>
                  <div><span>Product</span><strong>Flat-bed knitwear</strong></div>
                </div>
                <div className="capacity-panel">
                  <div><span>Low gauge</span><strong>3.5G · 5G · 7G</strong><small>200,000 pcs/year</small></div>
                  <div><span>High gauge</span><strong>12G · 14G · 16G</strong><small>800,000 pcs/year</small></div>
                </div>
              </Reveal>
              <Reveal className="about-gallery">
                <img className="about-large" src={showroom} alt="Topmode showroom" />
                <img src={sampleProduct} alt="Topmode flat-bed knitwear sample" />
                <img src={factory} alt="Topmode factory exterior" />
              </Reveal>
            </div>
            <Reveal className="goal-panel">
              <div><div className="goal-topline"><span className="goal-number">01</span><span className="goal-symbol"><SafetyCertificateOutlined /></span></div><h3>Quality</h3><p>Responsibility brings quality.</p></div>
              <div><div className="goal-topline"><span className="goal-number">02</span><span className="goal-symbol"><DollarOutlined /></span></div><h3>Cost</h3><p>Always offer a competitive price.</p></div>
              <div><div className="goal-topline"><span className="goal-number">03</span><span className="goal-symbol"><ClockCircleOutlined /></span></div><h3>Delivery</h3><p>Keep to the schedule.</p></div>
            </Reveal>
          </div>
        </section>

        <section className="section section-soft company-film-section" aria-labelledby="company-film-title">
          <div className="container">
            <Reveal className="company-film-card">
              <div className="company-film-copy">
                <span className="eyebrow">Inside Topmode</span>
                <h2 id="company-film-title">See our people, technology and factory in motion.</h2>
                <p>Take a closer look at the production environment behind TOPMODE’s one-million-piece annual knitwear capacity.</p>
                <div className="film-facts"><span><strong>3,000 m²</strong> integrated factory</span><span><strong>300</strong> skilled employees</span></div>
              </div>
              <div className="company-film-frame">
                <iframe
                  src="https://www.youtube.com/embed/DpbJ2KXl5jI"
                  title="TOPMODE company video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  loading="lazy"
                  allowFullScreen
                />
              </div>
            </Reveal>
          </div>
        </section>

        <section id="market" className="section section-dark">
          <div className="container">
            <Reveal><SectionHeading eyebrow="Global market" title="Growing with customers across six key markets" copy="Japan remains our largest market, supported by expanding partnerships across Korea, the USA, the United Kingdom, Italy and Vietnam." /></Reveal>
            <div className="chart-grid">
              <Reveal><figure><img src={marketChart} alt="Topmode market share chart for 2025" /><figcaption>Market share · 2025</figcaption></figure></Reveal>
              <Reveal><figure><img src={turnoverChart} alt="Topmode turnover and productivity history" /><figcaption>Turnover & productivity history</figcaption></figure></Reveal>
            </div>
            <Reveal className="market-logo-section">
              <div className="market-logo-intro">
                <div><span>Partner portfolio</span><h3>Brands grouped by market</h3></div>
                <p>Each card shows the representative brands served in that market.</p>
              </div>
              <div className="market-logo-cards">
                {brandLogoGroups.map((group) => <MarketLogoCard key={group.region} group={group} />)}
              </div>
            </Reveal>
            <Reveal className="table-shell market-table-shell">
              <table>
                <thead><tr><th>Market</th>
                <th>Distributor</th><th>Main brands</th></tr></thead>
                <tbody>{markets.map((item) => <tr key={item.region}>
                  <th>{item.region}</th>
                  {/* <td>{item.trading}</td> */}
                  <td>{item.distributors}</td><td>{item.brands}</td></tr>)}</tbody>
              </table>
            </Reveal>
          </div>
        </section>

        <section id="products" className="section section-light">
          <div className="container">
            <Reveal><SectionHeading eyebrow="Our products" title="Modern knitwear, developed across diverse techniques" copy="Fashion knitwear created with advanced flat-bed knitting technology, from classic structures to specialist WholeGarment, Intarsia, I-plating and In-lay construction." /></Reveal>
            <div className="product-showcase">
              <Reveal className="product-main"><img src={productBoard} alt="Topmode knitwear product range" /></Reveal>
              <Reveal className="product-side">
                <div className="product-image"><img src={knitStack} alt="Finished knitwear" /></div>
                <div className="product-image"><img src={yarn} alt="Yarn packages" /></div>
              </Reveal>
            </div>
            <Reveal className="technique-row">
              {['WholeGarment', 'Intarsia Knit · 16G', 'I-Plating', 'In-Lay Knit · 16G'].map((technique) => <span key={technique}><CheckCircleFilled /> {technique}</span>)}
            </Reveal>
          </div>
        </section>

        <section id="facilities" className="section section-soft">
          <div className="container">
            <Reveal><SectionHeading eyebrow="Machinery & facilities" title="A complete production system from programming to finishing" copy="Our upgraded equipment base combines Japanese SHIMA SEIKI technology, CI-XING triple-system machines and a comprehensive linking and finishing setup." /></Reveal>
            <Reveal className="facility-highlights">
              <div><ToolOutlined /><strong>96</strong><span>knitting machines</span></div>
              <div><ToolOutlined /><strong>206</strong><span>linking machines</span></div>
              <div><TeamOutlined /><strong>300</strong><span>skilled employees</span></div>
              <div><SafetyCertificateOutlined /><strong>100%</strong><span>process inspection</span></div>
            </Reveal>
            <Reveal className="machine-gallery">
              {[machineApex, machineWholeGarment, machineSsr, machineIntarsia, machineSvr, machineCixing, machineLine, embroidery].map((image, index) => <img key={image} src={image} alt={`Topmode machinery ${index + 1}`} />)}
            </Reveal>

            <Reveal className="data-card">
              <div className="data-card-heading"><div><span>Knitting</span><h3>Computerized knitting machines</h3></div><strong>96 sets</strong></div>
              <div className="table-shell">
                <table>
                  <thead><tr><th>Maker</th><th>Model</th><th>Gauge</th><th>Quantity</th></tr></thead>
                  <tbody>{knittingMachines.map((row) => <tr key={`${row[1]}-${row[2]}`}>{row.map((cell) => <td key={cell}>{cell}</td>)}</tr>)}</tbody>
                  <tfoot><tr><th colSpan="3">Total computerized knitting machines</th><th>96 sets</th></tr></tfoot>
                </table>
              </div>
            </Reveal>

            <div className="facility-data-grid">
              <Reveal className="data-card linking-card">
                <div className="data-card-heading"><div><span>Linking</span><h3>FENG MEI high-speed single motor</h3></div><strong>206 sets</strong></div>
                <div className="gauge-grid">{linkingMachines.map(([gauge, qty]) => <div key={gauge}><strong>{gauge}</strong><span>{qty} sets</span></div>)}</div>
              </Reveal>
              <Reveal className="data-card equipment-card">
                <div className="data-card-heading"><div><span>Other equipment</span><h3>Finishing & support machinery</h3></div></div>
                <details><summary>View full equipment list <ArrowRightOutlined /></summary>
                  <div className="table-shell compact-table"><table><thead><tr><th>Equipment</th><th>Maker / model</th><th>Unit</th><th>Qty.</th></tr></thead><tbody>{otherMachines.map((row) => <tr key={row[0]}>{row.map((cell) => <td key={cell}>{cell}</td>)}</tr>)}</tbody></table></div>
                </details>
              </Reveal>
            </div>

          </div>
        </section>

        <section id="production" className="section section-light production-section">
          <div className="container">
            <Reveal><SectionHeading eyebrow="Production process" title="From yarn preparation to finished knitwear" copy="Each production stage is presented independently, making the complete manufacturing sequence easy to follow from yarn storage through washing, ironing and drying." /></Reveal>
            <Reveal className="production-gallery">
              {productionGallery.map(([image, label]) => <figure key={label}><img src={image} alt={label} /><figcaption>{label}</figcaption></figure>)}
            </Reveal>
          </div>
        </section>

        <section id="factory-layout" className="section section-soft factory-layout-section">
          <div className="container">
            <Reveal><SectionHeading eyebrow="Factory layout" title="A clear plan for an integrated 3,000 m² operation" copy="The factory floor plan and production-flow legend are shown in their own section, separate from the production-process photography." /></Reveal>
            <Reveal className="flow-card factory-layout-card">
              <div className="flow-copy"><span className="eyebrow">Factory flow</span><h3>3,000 m² floor area</h3><p>All processes are integrated from knitting through third-party inspection.</p><div className="flow-steps">{['Knitting', 'Part checking', 'Linking', 'Washing', 'Ironing', 'Label sewing', 'Final checking', '3rd-party inspection'].map((step, index) => <span key={step}><i>{index + 1}</i>{step}</span>)}</div></div>
              <img src={factoryLayout} alt="Topmode factory layout and production flow" />
            </Reveal>
          </div>
        </section>

        <section id="quality" className="section section-dark quality-section">
          <div className="container">
            <Reveal><SectionHeading eyebrow="Quality control" title="100% inspection at every production process" copy="A disciplined control sequence protects workmanship, appearance, product safety and customer standards throughout production." /></Reveal>
            <div className="quality-layout">
              <Reveal className="quality-list">
                {['Knitting part checking', 'Linking checking', 'Light checking', 'Final checking', '3rd-party inspection room', 'Needle checking', 'Humidity checking', 'Dangerous objects management'].map((step, index) => <div key={step}><span>{String(index + 1).padStart(2, '0')}</span><p>{step}</p></div>)}
              </Reveal>
              <Reveal className="quality-gallery">{qualityGallery.map(([image, label]) => <figure key={label}><img src={image} alt={label} /><figcaption>{label}</figcaption></figure>)}</Reveal>
            </div>
          </div>
        </section>

        <section id="milestones" className="section section-light">
          <div className="container">
            <Reveal><SectionHeading eyebrow="Our milestones" title="A decade of capability, compliance and market expansion" /></Reveal>
            <Reveal className="timeline">
              {milestones.map(([year, copy], index) => <article key={year} className={index === milestones.length - 1 ? 'is-highlight' : ''}><div className="timeline-year">{year}</div><div className="timeline-dot" /><p>{copy}</p></article>)}
            </Reveal>
          </div>
        </section>

        <section id="contact" className="section contact-section">
          <div className="container contact-grid">
            <Reveal className="contact-copy">
              <span className="eyebrow">Connect with us</span>
              <h2>Let’s build the next knitwear program together.</h2>
              <div className="contact-people">
                <article><span>General Director · Japanese, English</span><h3>Trần Dương Minh</h3><a href="tel:+84913354095"><PhoneOutlined /> +84 913 354 095</a><a href="mailto:minhtd@topmodefa.vn"><MailOutlined /> minhtd@topmodefa.vn</a><small>Line: minhrr2000 · WeChat: TranDuongMinh</small></article>
                <article><span>Merchandiser · Japanese</span><h3>Hoàng Công Tân</h3><a href="tel:+84349868698"><PhoneOutlined /> +84 349 868 698</a><a href="mailto:qldh1@topmodefa.vn"><MailOutlined /> qldh1@topmodefa.vn</a></article>
                <article><span>Merchandiser · English</span><h3>Nguyễn Thị Thanh</h3><a href="tel:+84766244311"><PhoneOutlined /> +84 766 244 311</a><a href="mailto:qldh3@topmodefa.vn"><MailOutlined /> qldh3@topmodefa.vn</a></article>
              </div>
            </Reveal>
            <Reveal className="location-card">
              <a href="https://maps.app.goo.gl/nEkwBrnrSvUJuCrD7" target="_blank" rel="noreferrer"><img src={mapImage} alt="Map to Topmode Textile" /></a>
              <div className="location-details">
                <h3><EnvironmentOutlined /> TOPMODE TEXTILE CO., LTD.</h3>
                <p>Dan Phuong Industrial Zone, Dan Phuong District, Hanoi City 13007, Vietnam.</p>
                <p><PhoneOutlined /> +84-24 3297 9276 · Fax: +84-24 3297 9277</p>
                <p>Tax code: 0107335023</p>
                <a href="https://www.topmode.vn/" target="_blank" rel="noreferrer"><GlobalOutlined /> www.topmode.vn</a>
                <a className="map-link" href="https://maps.app.goo.gl/nEkwBrnrSvUJuCrD7" target="_blank" rel="noreferrer">Open Google Maps <ArrowRightOutlined /></a>
              </div>
            </Reveal>
          </div>
        </section>
      </main>

      <footer className="site-footer">
        <div><div className="footer-brand"><img src={logo} alt="Topmode logo" /><strong>TOPMODE TEXTILE CO., LTD.</strong></div><p>Flat-bed knitwear manufacturing · Hanoi, Vietnam</p></div>
        <div className="footer-qr"><img src={qrCode} alt="QR code for Topmode website" /><span>Scan to visit<br />topmode.vn</span></div>
        <span>© 2026 TOPMODE. All rights reserved.</span>
      </footer>
    </div>
  );
}

export default App;
